// extracted by mini-css-extract-plugin
export default {"numText":"StatsList_numText__YcVKX","statsText":"StatsList_statsText__lU81M","innerStats":"StatsList_innerStats__reWL8","infoPopup":"StatsList_infoPopup__LuAEw"};